export default __webpack_public_path__ + "static/media/agustin8.a539cef6.png";